
import { PICKERS_MODALS } from './Pickers.constants'
import PickerGroup from './components/PickerGroup'

export default {
  components: {
    PickerGroup,
  },
  props: {
    pickers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    shouldDisplayPickers() {
      return this.pickers.length > 0
    },
  },
  methods: {
    hasModal(id) {
      return Boolean(PICKERS_MODALS[id])
    },
    getModal(id) {
      return PICKERS_MODALS[id]
    },
  },
}
